import React from 'react';
import { MenuItem } from 'react-bootstrap';
import Dropdown from 'components/Dropdown';
import styles from './DropdownButtonSelectIcon.css';

class DropdownButtonSelectIcon extends React.Component {
  render() {
    const { options, disabled } = this.props;
    return (
      <Dropdown disabled={disabled} onSelect={this._onSelect}>
        <Dropdown.Toggle title={this._label()}></Dropdown.Toggle>
        <Dropdown.Menu>
          {options.map(o => {
            return (
              <MenuItem eventKey={o.id} key={o.id}>
                <i className={`${o.icon} ${styles.icon}`} />
                <span className={styles.status}> {o.name}</span>
              </MenuItem>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  _onSelect = (eventKey, event) => {
    const {
      input: { onChange, value },
      isDirtyForm,
      onDirtyFormCallback,
    } = this.props;
    if (isDirtyForm) {
      onDirtyFormCallback(event, eventKey, value);
    } else {
      onChange(eventKey);
    }
  };

  _label = () => {
    const {
      input: { value },
      options,
    } = this.props;
    let res = 'Loading...';
    options.forEach(o => {
      if (o.id === value) {
        res = o.name;
      }
    });
    return res;
  };
}

export default DropdownButtonSelectIcon;
